import { createTheme, type BaseTheme } from '../theme';
const theme = createTheme({
  components: {
    MuiDivider: {
      styleOverrides: {
        root: ({ theme }: { theme: BaseTheme }) => ({
          borderColor: theme.palette.divider,
        }),
      },
    },
  },
});

export default theme.components;
